import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createElementBlock as _createElementBlock } from "vue"

import { reactive, ref, computed } from 'vue';
import { useElementBounding } from '@vueuse/core';
import { IonButton } from '@ionic/vue';

interface Props {
    size?: number
    threshold?: number
    disabled?: boolean
}
interface Emits {
  (e: 'onSuccess'): void
  (e: 'onFailed'): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BasicSliderButton',
  props: {
    size: null,
    threshold: null,
    disabled: { type: Boolean }
  },
  emits: ["onSuccess", "onFailed"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'onSuccess'): void
  (e: 'onFailed'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    size?: number
    threshold?: number
    disabled?: boolean
};

_useCssVars(_ctx => ({
  "71a190ba": (_unref(validSizeContainer)),
  "54f43295": (_unref(willBeDragSuccess) ? '2px solid var(--ion-color-success, #59ff7a)' : '2px solid transparent'),
  "4f5b0d09": (_unref(willBeDragSuccess) ? 'var(--ion-color-success-shade, #28ba62)' : '#ddd'),
  "0a6bc942": (props.disabled ? 'not-allowed' : 'grab'),
  "6b24be6f": (props.disabled ? .75 : 1),
  "06beeafe": (_unref(validSizeBtn))
}))




const containerNode = ref<HTMLElement | null>(null)
const draggableNode = ref<HTMLElement | null>(null)
const moveLeft = ref(0)
const liveProgress = ref(0)

const isTouchDevice = computed(() => ('ontouchstart' in window) || (navigator.maxTouchPoints > 0))
const validSizeBtn = computed(() => {
    if (!props.size) return '64px'

    return `${props.size}px`
})
const validSizeContainer = computed(() => {
    if (!props.size) return '72px'

    return `${props.size + 8}px`
})

const validThreshold = computed(() => {
    if (!props.threshold) return 0.7
    if (props.threshold > 1) return 1
    if (props.threshold < 0) return 0

    return props.threshold
})

const maxDragPosX = computed(() => {
    if (!isValidDrag) return 0

    const { left: containerLeft, right: containerRight } = containerNode.value!.getBoundingClientRect()
    const { width: draggedNodeWidth } = reactive(useElementBounding(draggableNode))

    return containerRight - containerLeft - draggedNodeWidth
})

const willBeDragSuccess = computed(() => (liveProgress.value > validThreshold.value))

const isValidDrag = () => (containerNode.value && draggableNode.value)

const handleOnTouchMove = (event: TouchEvent) => {
    if (props.disabled) return
    if (!isValidDrag) return

    // In theory it should be 2, but 1.66 works better
    const halfWidthBtn = Math.floor((props.size ?? 64) / 1.66) 
    const dragXValue = event.touches[0].clientX - halfWidthBtn
    const isNormalDrag = (dragXValue >= 0 && dragXValue <= (maxDragPosX.value))

    if (isNormalDrag) {
        liveProgress.value = Math.round(((dragXValue / maxDragPosX.value)  + Number.EPSILON) * 100) / 100
        moveLeft.value = dragXValue
    }
}

const handleOnTouchEnd = () => {
    if (props.disabled) return
    if (!isValidDrag) return

    liveProgress.value = 0

    const isSuccess = moveLeft.value >= (maxDragPosX.value * validThreshold.value) 

    if (isSuccess) {
        emit('onSuccess')
    } else {
        emit('onFailed')
    }

    moveLeft.value = 0 
}


return (_ctx: any,_cache: any) => {
  return (!_unref(isTouchDevice))
    ? (_openBlock(), _createBlock(_unref(IonButton), {
        key: 0,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('onSuccess')))
      }, {
        default: _withCtx(() => [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(" OK ")
          ])
        ]),
        _: 3
      }))
    : (_openBlock(), _createElementBlock("div", {
        key: 1,
        ref_key: "containerNode",
        ref: containerNode,
        class: "slider--wrapper"
      }, [
        _createElementVNode("div", {
          ref_key: "draggableNode",
          ref: draggableNode,
          class: "slider--inner",
          style: _normalizeStyle({ left: `${moveLeft.value}px` }),
          onTouchmove: _cache[1] || (_cache[1] = ($event: any) => (handleOnTouchMove($event))),
          onTouchend: _cache[2] || (_cache[2] = ($event: any) => (handleOnTouchEnd()))
        }, [
          _renderSlot(_ctx.$slots, "default", {}, () => [
            _createTextVNode(" OK ")
          ])
        ], 36)
      ], 512))
}
}

})